import { useCallback, useEffect, useRef } from 'react';

const useTimeout = () => {
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    return useCallback((cb: () => void, timeout: number) => {
        setTimeout(() => {
            if (isMounted.current) cb();
        }, timeout);
    }, []);
};

export default useTimeout;
